import { NgModule } from '@angular/core';
import { HomeComponent } from './home.component';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SharedModule } from 'src/app/pages/shared.module';
import { HomeRoutingModule } from './home-routing.module';
import { LottieModule } from 'ngx-lottie';
import { HomeDesktopComponent } from './templates/desktop/home-desktop.component';
import { HomeMobileComponent } from './templates/mobile/home-mobile.component';

// Note we need a separate function as it's required
// by the AOT compiler.
export function playerFactory() {
  return import('lottie-web');
}

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    HomeRoutingModule,
    SharedModule,
    LottieModule.forRoot({ player: playerFactory })
  ],
  declarations: [
    HomeComponent,
    HomeDesktopComponent,
    HomeMobileComponent
  ],
  exports: [
    HomeComponent
  ]
})

export class HomeModule { }
